import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@nextui-org/react";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { IoChevronDown } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { format, isValid } from "date-fns";

import MCalendar from "./Kit/MCalendar";
import { getDateFnsLocale } from "../utils/dateUtils";

const formatRange = (dateRangeValue, locale) => {
  const start = dateRangeValue?.startDate ? new Date(dateRangeValue.startDate) : null;
  const end = dateRangeValue?.endDate ? new Date(dateRangeValue.endDate) : null;
  if (!start || !isValid(start) || !end || !isValid(end)) return null;
  return `${format(start, "d MMM", { locale })} – ${format(end, "d MMM yyyy", {
    locale,
  })}`;
};

const CalendarDropdown = ({
  months = 2,
  maxDate = null,
  minDate = null,
  onDateRangeChange = (range) => {},
  fetchData = null,
  dateRangeValue = null,
  showShortcuts = true,
  triggerClassName = "",
}) => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);
  const rangeLabel = formatRange(dateRangeValue, getDateFnsLocale(i18n.language));

  return (
    <Popover
      placement="bottom-right"
      aria-label="Calendar popup"
      showArrow={false}
      offset={10}
      shouldCloseOnBlur
      isOpen={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
    >
      <PopoverTrigger>
        <div
          className={`bg-white border border-[#E5E5E5] hover:border-[#A3A3A3] duration-300 px-[12px] h-[40px] rounded-lg flex items-center cursor-pointer gap-[8px] text-[#404040] ${triggerClassName}`}
        >
          <MdOutlineCalendarMonth
            size={18}
            className="text-[#737373] shrink-0"
          />
          <span className="text-[14px] whitespace-nowrap">{rangeLabel || t("Date")}</span>
          <IoChevronDown
            size={16}
            className={`text-[#737373] shrink-0 transition-transform duration-300 ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-auto min-w-max">
        <MCalendar
          dateRange={dateRangeValue}
          months={months}
          minDate={minDate}
          maxDate={maxDate}
          showShortcuts={showShortcuts}
          setDateRange={(dates) => {
            if (dates?.endDate) {
              onDateRangeChange(dates);
              setIsOpen(false);
            }
          }}
        />
      </PopoverContent>
    </Popover>
  );
};

export default CalendarDropdown;
